import React from "react";

import { ExportServerButton } from "../../../components/dialogs/ExportDialog/ExportServerButton";

export const ExportArticleButton = (props) => (
	<ExportServerButton
		{...props}
		endpoint="pricelist-articles"
		type="xlsx"
		label="XLSX"
		sort={["code", "DESC"]}
	/>
);
